import { useMy } from '@/hooks/useMy';
import { Job } from '@/types';
import { UseExtendInfiniteQueryOptions } from '@/utils/api';
import { sToMs } from '@/utils/date.util';

export function useGetDownloads(
  options?: UseExtendInfiniteQueryOptions<Job[]>
) {
  return useMy(
    {
      resource: 'job',
      query: '#home/export-',
    },
    { refetchInterval: sToMs(5), ...options }
  );
}
